import request from "@/utils/request";

// 服务列表
export function getServiceList(params) {
  return request({
    url: "/wechat/weixin/service/list",
    method: "GET",
    params
  });
}
// 服务详情
export function getServiceDetail(params) {
  return request({
    url: `/wechat/weixin/service/${params}`,
    method: "GET"
  });
}
// 申请服务
export function addApplyService(data) {
  return request({
    url: "/wechat/weixin/apply/add",
    method: "POST",
    data
  });
}
// 申请记录列表
export function getApplyRecored(params) {
  return request({
    url: "/wechat/weixin/apply/list",
    method: "GET",
    params
  });
}
// 申请记录详情
export function getRecoredDetail(id) {
  return request({
    url: `/wechat/weixin/apply/detail/${id}`,
    method: "GET"
  });
}
